import { SeoLink, SeoMeta } from "@/types/sites";

const SeoFields = (
    seoLinkField: SeoLink[],
    seoMetaField: SeoMeta[]
): null | React.ReactElement[] => {
    const linkFields = seoLinkField.map((field) => (
        <link
            key={`cmsLink_${field.id}`}
            rel={field.rel || undefined}
            href={field.href || undefined}
            hrefLang={field.hreflang || undefined}
        ></link>
    ));
    const metaFields = seoMetaField.map((field) => (
        <meta
            key={`cmsMeta_${field.id}`}
            property={field.property || undefined}
            content={field.content || undefined}
        />
    ));
    const seoFields = [...linkFields, ...metaFields];

    return seoFields.length > 0 ? seoFields : null;
};

export default SeoFields;
